import React from 'react';
import MyBread from '../../components/Breadcrumbs';
import UsersInfo from '../../components/UsersInfo';
import { Wrapper } from 'styles/styles';

export default function User() {
  return (
    <>
      <Wrapper>
        <MyBread />
        <UsersInfo />
      </Wrapper>
    </>
  )
}
